import React, { useEffect, useState } from 'react'
import {
  makeStyles,
  IconButton,
  TextField,
  TableCell,
  TableRow,
  Tooltip,
  Button,
} from "@material-ui/core";
import moment from "moment";
import { useDispatch, useSelector } from 'react-redux';
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import NumberFormat from 'react-number-format';
import InfoIcon from '@material-ui/icons/Info';
import DeleteIcon from '@material-ui/icons/Delete';
import CachedIcon from '@material-ui/icons/Cached';
import { red } from '@material-ui/core/colors';
import MessageIcon from '@material-ui/icons/Message';
import BackspaceIcon from '@material-ui/icons/Backspace';
import { ModalAfiliadoLiq } from '../../../UI/ModalAfiliadoLiq';
import { startAlerta } from '../../../../../actions/ui/alertas';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import InfoHistorialIcon from '../../../../autorizaciones/UI/InfoHistorialIcon';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { deleteLineaInsumoNoGrabada, deleteLineaInsumo, updateLineaInsumo, insertLineaInsumo } from '../../../../../actions/liquidaciones/liquidaciones';
import { AlertFinalizadoStepper } from '../../../../stepper/AlertFinalizadoStepper';
import { ModalNotaItem } from '../ModalNotaItem';
import { LIQUIDACIONES_COMPROBANTES_ESTADOS, LIQUIDACIONES_LINEA_COMPORBANTE, LIQUIDACIONES_TIPO_INGRESO_LINEA } from '../../../../../utils/constants';
import { ModalTrackingLineaComprobante } from '../ModalTrackingLineaComprobante';
import { validarSoloUnPermiso } from '../../../../../helpers/permisos';
import { LIQUIDACIONES_GESTION_PERMISOS } from '../../../../../utils/permisos';
import { Edit, PersonAddDisabled } from '@material-ui/icons';
import { ModalModificarLinea } from '../lineasPrestacion/ModalModificarLinea';

const useStyles = makeStyles((theme) => ({
  iconInfo: {
    fontSize: 16,
  },
  cursorDefault: {
    cursor: 'default'
  }
}));

export const LineaInsumoItem = ({ item, nroLinea, formatCurrencyPesos, disabledLinea, comprobanteSeleccionado, lineaComprobante }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { permisos: permisosUser } = useSelector(
    (state) => state.auth
  );

  const [importe, setImporte] = useState(item.importe);
  const [cantidad, setCantidad] = useState(item.cantidad);
  const [fechaPrestacion, setFechaPrestacion] = useState(item.fechaPrestacion);
  const [afiliadoInexistente, setAfiliadoInexistente] = useState(item.afiliadoInexistente);
  const [fechaInternacionDesde, setFechaInternacionDesde] = useState(item.fechaInternacionDesde);
  const [fechaInternacionHasta, setFechaInternacionHasta] = useState(item.fechaInternacionHasta);
  const [nroValidacion, setNroValidacion] = useState(item.nroValidacion);
  const [idSolicitud, setIdSolicitud] = useState(item.idSolicitud);
  // const [idAgenda, setIdAgenda] = useState(item.idAgenda);
  const [openModalAfiliado, setOpenModalAfiliado] = useState(false);
  const [importeDebito, setImporteDebito] = useState(item.importeDebito);
  const [comentario, setComentario] = useState(item.comentario);
  const [afiliado, setAfiliado] = useState(
    { idAfiliado: item?.idAfiliado, carnet: item?.carnet, apellidoNombre: item?.apellidoNombre }
  );
  const [openModalHistorialCambiosLinea, setOpenModalHistorialCambiosLinea] = useState(false);
  const [confirmarEliminar, setConfirmarEliminar] = useState(false);
  const [openModalNota, setOpenModalNota] = useState(false);
  const [deleteDebito, setDeleteDebito] = useState(false);
  const [openModalModificarLinea, setOpenModalModificarLinea] = useState(false);

  const subtotal = (importe * cantidad)

  const disabled = !item.esCodigoLiquidacion && item.lineaExistente

  const handleSaveLine = (deleteDebito = false) => {
    if (!importe || importe === 0) {
      dispatch(startAlerta("Debe ingresar un importe.", "warning", "Error"));
    }
    else if (!item.esCodigoLiquidacion && (!afiliado?.idAfiliado && !afiliadoInexistente)) {
      dispatch(startAlerta("Debe seleccionar un afliliado para grabar la línea.", "warning", "Error"));
    }
    else if (item?.idTipoIngreso === LIQUIDACIONES_TIPO_INGRESO_LINEA.CARGA_POR_IDSOLICITUD && !fechaPrestacion) {
      dispatch(startAlerta("Debe cargar una fecha de prestación.", "warning", "Error"));
    }
    else if (checkDate()) {
      if (!item.lineaExistente)
        dispatch(insertLineaInsumo(item.idComprobante, fechaPrestacion, item.idMaterial,
          cantidad, importe, afiliado?.idAfiliado, fechaInternacionDesde,
          fechaInternacionHasta, nroValidacion, idSolicitud,
          afiliadoInexistente, true /*, idAgenda */));
      else
        dispatch(updateLineaInsumo(item.idItem, item.idComprobante,
          importe, deleteDebito ? 0 : importeDebito, fechaPrestacion, comentario,
          afiliadoInexistente, setOpenModalNota));
    }
  }

  const checkDate = () => {
    if (fechaInternacionDesde || fechaInternacionHasta) {
      if (!fechaInternacionDesde || !fechaInternacionHasta) {
        dispatch(startAlerta("Al indicar Fecha Internación Desde la Fecha Internación Hasta es requerida.", "warning", "Error"));
        return false;
      }

      if (moment(fechaPrestacion).isBefore(moment(fechaInternacionDesde), "day") || moment(fechaPrestacion).isAfter(moment(fechaInternacionHasta), "day")) {
        dispatch(startAlerta("Verifique las fechas.", "warning", "Error"));
        return false;
      }
    }

    return true;
  }

  useEffect(() => {
    setImporte(item?.importe);
    setCantidad(item?.cantidad);
    setFechaPrestacion(item?.fechaPrestacion);
    setAfiliadoInexistente(item?.afiliadoInexistente);
    setNroValidacion(item?.nroValidacion);
    setIdSolicitud(item?.idSolicitud);
    setImporteDebito(item?.importeDebito);
    setAfiliado({ idAfiliado: item?.idAfiliado, carnet: item?.carnet, apellidoNombre: item?.apellidoNombre });
  }, [item])

  return (
    <>
      <TableRow>
        <TableCell align="center" sx={{ padding: "10px" }}>
          <div style={{ display: 'flex' }}>
            {openModalHistorialCambiosLinea &&
              <ModalTrackingLineaComprobante
                open={openModalHistorialCambiosLinea}
                closeModalHandler={() => {
                  setOpenModalHistorialCambiosLinea(false);
                }}
                idTipoLinea={LIQUIDACIONES_LINEA_COMPORBANTE.INSUMO}
                idComprobante={item.idComprobante}
                idItem={item.idItem}
              />
            }
            {!item.newLine &&
              <InfoHistorialIcon
                onClick={() => setOpenModalHistorialCambiosLinea(true)}
              />
            }
          </div>
        </TableCell>
        <TableCell align="center" sx={{ padding: "10px" }}>
          <div style={{ display: 'flex' }}>
            {openModalModificarLinea &&
              <ModalModificarLinea
                open={openModalModificarLinea}
                closeModalHandler={() => {
                  setOpenModalModificarLinea(false);
                }}
                idTipoLinea={LIQUIDACIONES_LINEA_COMPORBANTE.INSUMO}
                idComprobante={item.idComprobante}
                comprobanteSeleccionado={comprobanteSeleccionado}
                lineaComprobante={lineaComprobante}
                idItem={item.idItem}
                item={item}
                title="Modificar Linea Insumo"
                importeDebito={importeDebito}
                setImporteDebito={setImporteDebito}
              />
            }
            {!item.newLine &&
              <IconButton onClick={() => setOpenModalModificarLinea(true)}>
                <Edit
                  color="primary"
                />
              </IconButton>
            }
          </div>
        </TableCell>
        <TableCell>
          {nroLinea}
        </TableCell>
        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>
          {afiliado?.carnet &&
            `${afiliado?.carnet} / ${afiliado?.apellidoNombre}`
          }
          {afiliadoInexistente &&
            <Tooltip
              title={
                <>
                  <span className={classes.iconInfo}>
                    {`Afiliado Inexistente`}
                  </span>
                </>
              }
            >
              <IconButton style={{ padding: 0, marginLeft: 4 }}
                color="inherit"
                className={classes.cursorDefault}
              >
                <PersonAddDisabled style={{ color: red[600] }} />
              </IconButton>
            </Tooltip>
          }
          {afiliadoInexistente &&
            ` ${afiliadoInexistente}`
          }
          <div style={{ display: 'inline-flex' }}>
            {(item.esCodigoLiquidacion || !item.lineaExistente || item.afiliadoInexistente) &&
              <Tooltip
                title={
                  <>
                    <span className={classes.iconInfo}>
                      {`${afiliado?.idAfiliado || afiliadoInexistente
                        ? 'Cambiar Afiliado'
                        : !item.lineaExistente
                          ? 'Seleccionar Afiliado'
                          : 'Sin Afiliado'}`}
                    </span>
                  </>
                }
              >
                <IconButton
                  color="inherit"
                  className={(item.lineaExistente && !item.afiliadoInexistente && !item.esCodigoLiquidacion) && classes.cursorDefault}
                  onClick={() => {
                    if (!item.lineaExistente || item.afiliadoInexistente || item.esCodigoLiquidacion) setOpenModalAfiliado(true)
                  }}
                >
                  {afiliado?.idAfiliado || afiliadoInexistente
                    ?
                    <CachedIcon />
                    :
                    <PersonOutlineIcon />
                  }
                </IconButton>
              </Tooltip>
            }
            {true &&
              <ModalAfiliadoLiq
                open={openModalAfiliado}
                onCloseModal={() => {
                  setOpenModalAfiliado(false);
                }}
                setAfiliado={setAfiliado}
                lineaExistente={item.lineaExistente}
                esCodigoLiquidacion={item.esCodigoLiquidacion}
                showAfiInexistente={!item.esCodigoLiquidacion}
                setAfiliadoInexistente={setAfiliadoInexistente}
              />
            }
          </div>
        </TableCell>
        {/* <TableCell component="th" scope="row">
              {item.codMat}
            </TableCell> */}
        <TableCell component="th" scope="row">
          {`${item?.desMat.substring(0, 25)}${item?.desMat.length > 25 ? '... ' : ''}`}
          {item?.desMat.length > 25 &&
            <Tooltip
              title={
                <>
                  <span className={classes.iconInfo}>
                    {item?.desMat}
                  </span>
                </>
              }
            >
              <span><strong>
                {'VER'}
              </strong></span>
            </Tooltip>
          }
        </TableCell>
        <TableCell component="th" scope="row">
          {/* {(item.idTipoIngreso === LIQUIDACIONES_TIPO_INGRESO_LINEA.CARGA_MANUAL || item.newLine) && */}
          <>
            {!disabledLinea &&
              <Tooltip
                title={
                  <>
                    <span className={classes.iconInfo}>
                      {`Eliminar Linea`}
                    </span>
                  </>
                }
              >
                <IconButton style={{ padding: 0, marginLeft: 4 }}
                  color="inherit"
                  onClick={() => {
                    if (!item.newLine)
                      setConfirmarEliminar(true);
                    else
                      dispatch(deleteLineaInsumoNoGrabada(item.idItem))
                  }}
                >
                  <BackspaceIcon style={{ color: red[600] }} />
                </IconButton>
              </Tooltip>
            }
            <AlertFinalizadoStepper
              open={confirmarEliminar}
              pregunta={"Eliminar línea"}
              dialogText={`Esta seguro de eliminar la línea?`}
              buttonCancel={"Cancelar"}
              buttonSubmit={"Confirmar"}
              handleClose={() => setConfirmarEliminar(false)}
              handleSend={() => {
                dispatch(deleteLineaInsumo(item.idItem, item.idMaterial, item.idComprobante, item.idAfiliado));
                setConfirmarEliminar(false);
              }}
            />
          </>
          {/* } */}
        </TableCell>
        <TableCell align="center">
          <MuiPickersUtilsProvider
            locale={esLocale}
            utils={DateFnsUtils}
          >
            <KeyboardDatePicker
              margin="normal"
              style={{ minWidth: 145 }}
              id="dialogFechaPrestacion"
              format="dd/MM/yyyy"
              okLabel="Aceptar"
              required={true}
              disabled={(disabled && item.idTipoIngreso !== LIQUIDACIONES_TIPO_INGRESO_LINEA.CARGA_POR_IDSOLICITUD) ||
                (item.esCodigoLiquidacion && item.lineaExistente)
              }
              clearLabel="Limpiar"
              cancelLabel="Cancelar"
              maxDate={new Date()}
              // minDate={idEfHorario===0 && new Date()}
              // minDateMessage={`La fecha no puede ser anterior a la fecha actual`}
              value={
                moment(fechaPrestacion).isValid()
                  ? moment(fechaPrestacion)
                  : null
              }
              onChange={(date) => {
                setFechaPrestacion(date);
              }}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
            />
          </MuiPickersUtilsProvider>
          {/* {new Date(item.fechaPrestacion).toLocaleString("es", optionsfecha)} */}
        </TableCell>
        <TableCell align="right">
          <TextField
            margin="normal"
            name="cantidad"
            value={cantidad}
            autoComplete="off"
            disabled={disabled || (item.esCodigoLiquidacion && item.lineaExistente)}
            onChange={(e) => {
              if (e.target.value > 0) setCantidad(e.target.value)
            }}
            type='number'
            required
          //fullWidth
          />
        </TableCell>
        <TableCell align="left">
          <NumberFormat
            style={{ maxWidth: 100 }}
            onValueChange={(values) => {
              setImporte(values.floatValue);
            }}
            value={importe}
            disabled={(disabled && item.importe !== 0) || disabledLinea}
            thousandSeparator="."
            decimalSeparator=","
            // isNumericString
            prefix={"$ "}
          />
        </TableCell>
        {false &&
          <TableCell align="center">
            {!item.esCodigoLiquidacion &&
              <MuiPickersUtilsProvider
                locale={esLocale}
                utils={DateFnsUtils}
              >
                <KeyboardDatePicker
                  margin="normal"
                  style={{ minWidth: 145 }}
                  id="dialogFechaInternacionDesde"
                  format="dd/MM/yyyy"
                  okLabel="Aceptar"
                  disabled={disabled}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  // minDate={idEfHorario===0 && new Date()}
                  // minDateMessage={`La fecha no puede ser anterior a la fecha actual`}
                  value={
                    moment(fechaInternacionDesde).isValid()
                      ? moment(fechaInternacionDesde)
                      : null
                  }
                  onChange={(date) => {
                    setFechaInternacionDesde(date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            }
          </TableCell>
        }
        {false &&
          <TableCell align="center">
            {!item.esCodigoLiquidacion &&
              <MuiPickersUtilsProvider
                locale={esLocale}
                utils={DateFnsUtils}
              >
                <KeyboardDatePicker
                  margin="normal"
                  style={{ minWidth: 145 }}
                  id="dialogFechaInternacionHasta"
                  format="dd/MM/yyyy"
                  okLabel="Aceptar"
                  disabled={disabled}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  maxDate={new Date()}
                  // minDate={idEfHorario===0 && new Date()}
                  // minDateMessage={`La fecha no puede ser anterior a la fecha actual`}
                  value={
                    moment(fechaInternacionHasta).isValid()
                      ? moment(fechaInternacionHasta)
                      : null
                  }
                  onChange={(date) => {
                    setFechaInternacionHasta(date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            }
          </TableCell>
        }
        {comprobanteSeleccionado.comprobanteContrato.efectorFacturacion.validaPortalPrestador &&
          <TableCell align="right">
            <TextField
              margin="normal"
              name="nroValidacion"
              value={nroValidacion ?? ''}
              autoComplete="off"
              disabled={disabled || item.lineaExistente}
              onChange={(e) => { setNroValidacion(e.target.value) }}
              type='number'
            //fullWidth
            />
          </TableCell>
        }
        {comprobanteSeleccionado.comprobanteContrato.efectorFacturacion.validaAutorizacion &&
          <TableCell align="right">
            <TextField
              margin="normal"
              name="idSolicitud"
              value={idSolicitud}
              autoComplete="off"
              disabled={disabled || item.lineaExistente}
              onChange={(e) => { setIdSolicitud(e.target.value) }}
              type='number'
            //fullWidth
            />
          </TableCell>
        }
        {/* <TableCell align="right">
              <TextField
                margin="normal"
                name="idAgenda"
                value={idAgenda}
                autoComplete="off"
                disabled={disabled}
                onChange={(e) => {setIdAgenda(e.target.value)}}
                type='number'
                //fullWidth
              />
            </TableCell> */}
        <TableCell align="left">{`${formatCurrencyPesos(subtotal)}`}</TableCell>
        <TableCell align="center">
          <div style={{ display: 'flex' }}>
            {item.idMotivoDebito &&
              <>
                {!disabledLinea &&
                  <Tooltip
                    title={
                      <>
                        <span className={classes.iconInfo}>
                          {`Eliminar Debito`}
                        </span>
                      </>
                    }
                  >
                    <IconButton style={{ padding: 0, marginLeft: 4 }}
                      disabled={!validarSoloUnPermiso(permisosUser, LIQUIDACIONES_GESTION_PERMISOS.MODIFICAR_DEBITO)}
                      color="inherit"
                      onClick={() => {
                        setDeleteDebito(true);
                        setOpenModalNota(true);
                      }}
                    >
                      <DeleteIcon style={{ color: validarSoloUnPermiso(permisosUser, LIQUIDACIONES_GESTION_PERMISOS.MODIFICAR_DEBITO) && red[600] }} />
                    </IconButton>
                  </Tooltip>
                }
                <Tooltip
                  title={
                    <>
                      <span className={classes.iconInfo}>
                        {`DEBITO: ${item.motivoDebito}`}
                      </span>
                    </>
                  }
                  className={classes.cursorDefault}
                >
                  <IconButton style={{ padding: 0, marginLeft: 4 }}
                    color="inherit"
                  >
                    <InfoIcon />
                  </IconButton>
                </Tooltip>
              </>
            }
            {item.lineaExistente &&
              <NumberFormat
                style={{ maxWidth: 100, marginLeft: 10 }}
                onValueChange={(values) => {
                  setImporteDebito(values.floatValue > 0 ? -values.floatValue : values.floatValue);
                }}
                isAllowed={(values) => {
                  const { floatValue } = values;
                  return floatValue >= (-importe * cantidad) || !floatValue;
                }}
                value={!importeDebito ? 0 : importeDebito}
                disabled={(!item.lineaExistente || item.esCodigoLiquidacion || disabledLinea ||
                  !validarSoloUnPermiso(permisosUser, LIQUIDACIONES_GESTION_PERMISOS.MODIFICAR_DEBITO) ||
                  item.importe === 0 || !item.idAfiliado) && (comprobanteSeleccionado?.expediente?.idEstado !==
                    LIQUIDACIONES_COMPROBANTES_ESTADOS.RETORNADA && !item.esCodigoLiquidacion && importeDebito === 0)
                }
                thousandSeparator="."
                decimalSeparator=","
                // isNumericString
                prefix={"$ "}
              />
            }
            {item.comentario &&
              <Tooltip
                title={
                  <>
                    <span className={classes.iconInfo}>
                      {item.comentario}
                    </span>
                  </>
                }
              >
                <IconButton style={{ padding: 0, marginLeft: 10 }}
                  color="inherit"
                >
                  <MessageIcon /* style={{ color: red[600] }} */ />
                </IconButton>
              </Tooltip>
            }
          </div>
        </TableCell>
        <TableCell align="center">                {/* TOTAL A PAGAR */}
          {formatCurrencyPesos((importe * cantidad) + (item.importeDebito ?? 0))}
        </TableCell>
        <TableCell>
          <Button
            style={{ fontSize: "0.8rem" }}
            disabled={disabledLinea}
            onClick={() => {
              if ((importeDebito ?? 0) !== (item.importeDebito ?? 0))
                if (importeDebito && importeDebito > 0)
                  dispatch(startAlerta("El Importe Débito no puede ser mayor a cero.", "warning", "Error"));
                else
                  setOpenModalNota(true);
              else
                handleSaveLine();
            }}
            variant="contained"
            color="primary"
          >
            Grabar
          </Button>
          <ModalNotaItem
            open={openModalNota}
            close={() => {
              setOpenModalNota(false);
              setDeleteDebito(false);
            }}
            titulo={"Agregar Nota Modificación Débito"}
            carMin={10}
            carMax={500}
            comentario={comentario}
            setComentario={setComentario}
            handleSaveLine={() => {
              if (deleteDebito)
                setImporteDebito(0);
              handleSaveLine();
            }}
          />
        </TableCell>
      </TableRow>
    </>
  );
}